; (function (inovestor, undefined) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.fund = inovestor.ms.fund || {};
})(inovestor);


; (function (fund, undefined) {
    // Create plugin namespace with any desired config variable
    fund.fees = {
        config: {
            apiRelativeUrl: 'mutualfunds/fees?symbol={symbol}'
        }
    };

})(inovestor.ms.fund);


(function ($, ko, inovestor, undefined) {
    inovestor.ms.fund.fees.viewModels = {};

    inovestor.ms.fund.fees.viewModels.feesViewModel = function () {

        var self = this;

        self.fees = ko.observable();
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.fees() != null;
        }, this);

        self.groupedCodes = ko.observableArray();

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.fund.fees.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);


; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsFundFees';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsFundFees.defaults;
        this._viewModel = new inovestor.ms.fund.fees.viewModels.feesViewModel();

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Call init
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.fees;
            var filePath = plugin.options.templatePaths.fees;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'fees.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.bindModel();
                plugin.render();
            }).then(function () {
                // Call Search
                plugin.search(plugin.options.symbol).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // Search for a particular symbol
        search: function (symbol) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";

            // Update options
            plugin.options.symbol = symbol;

            // Setup API url with term
            var feesUrl = inovestor.ms.core.stringFormat(inovestor.ms.fund.fees.config.apiRelativeUrl, { symbol: symbol });

            // Reset relevant Data before calling API
            plugin._viewModel.fees(null);
            plugin._viewModel.groupedCodes([]);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(feesUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {
                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    plugin._orderSalesCharges(data);
                    plugin._formatSalesCharges(data);
                    plugin._viewModel.fees(data);
                    plugin.groupFundCodes();
                }
                plugin.update();
            });
        },

        groupFundCodes: function () {
            var plugin = this;
            if (!plugin._viewModel.hasValidData())
                return;

            var x = {};
            var fundCodes = plugin._viewModel.fees().fundCodesFamily;
            if (!inovestor.ms.core.isNullOrUndefined(fundCodes)) {
                var i = fundCodes.length;
                while (i--) {
                    var sHash = fundCodes[i].salesChargeOptionType.toString();
                    if (typeof (x[sHash]) == "undefined")
                        x[sHash] = [];
                    x[sHash].push(fundCodes[i].code);
                }
                plugin._viewModel.groupedCodes(x);
            }
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        _orderSalesCharges: function (data) {
            if (!inovestor.ms.core.isNullOrUndefined(data.salesCharges)) {
                var orderedSalesChargeList = [null, null, null];
                for (var index in data.salesCharges) {
                    var salesCharge = data.salesCharges[index];
                    switch (salesCharge.salesChargeOptionType) {
                        case 'initialSalesCharge':
                            orderedSalesChargeList[0] = salesCharge;
                            break;
                        case 'deferredSalesCharge':
                            orderedSalesChargeList[1] = salesCharge;
                            break;
                        case 'lowSalesCharge':
                            orderedSalesChargeList[2] = salesCharge;
                            break;
                        default:
                            break;
                    }
                }
                data.salesCharges = [];
                for (var index in orderedSalesChargeList) {
                    if (!inovestor.ms.core.isNullOrUndefined(orderedSalesChargeList[index]))
                        data.salesCharges.push(orderedSalesChargeList[index]);
                }
            }
        },

        _formatSalesCharges: function (data) {
            if (!inovestor.ms.core.isNullOrUndefined(data.salesCharges)) {
                for (var index in data.salesCharges) {
                    var salesCharge = data.salesCharges[index];
                    // Replacing \n\r + Order of table rows 
                    if (salesCharge.salesChargeOptionType == "deferredSalesCharge") {
                        salesCharge.descriptionInPercentEn = salesCharge.descriptionInPercentEn.replace(/\n/g, '<br />');
                        salesCharge.descriptionInPercentFr = salesCharge.descriptionInPercentFr.replace(/\n/g, '<br />');
                    }
                    // Load Load Charge
                    if (salesCharge.salesChargeOptionType == "initialSalesCharge" || salesCharge.salesChargeOptionType == "lowSalesCharge") {
                        salesCharge.descriptionInPercentEn = salesCharge.descriptionInPercentEn.replace(/\n/g, '<br />');
                        salesCharge.descriptionInPercentFr = salesCharge.descriptionInPercentFr.replace(/\n/g, '<br />');
                    }
                }
            }
        },

        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.fees.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsFundFees = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };
    $.fn.inoMsFundFees.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            fees: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (fund, undefined) {
    fund.fees.resources = fund.fees.resources || {};
    fund.fees.resources["en"] = {
        quickFacts: "Portfolio Manager",
        fundCode: "Fund Codes",
        dateSeriesStarted: "Date series started",
        totalValueFund: "Fund value as of",
        howSold: "How to buy",
        soldIn: "Sold In",
        retirementSavingsPlanInitial: "RSP Initial",
        retirementSavingsPlanSubsequent: "RSP Subsequent",
        nonRetirementSavingsPlanInitial: "Non-RSP Initial",
        nonRetirementSavingsPlanSubsequent: "Non-RSP Subsequent",
        preauthorizedContributionAllowed: "PAC Allowed",
        preauthorizedContributionInitial: "PAC Initial",
        preauthorizedContributionSubsequent: "PAC Subsequent",
        systematicWithdrawalPlanAllowed: "SWP Allowed",
        systematicWithdrawalPlanMinimumBalance: "SWP Min Balance",
        systematicWithdrawalPlanMinimumWithdrawal: "SWP Min Withdrawal",
        managementFee: "Management Fee",
        managementExpenseRatio: "Management expense ratio (MER)",
        managementExpenseRatioShort: "MER",
        load: "Load",
        isChoiceOfFrontOrBackFee: "Choice of front or back ",
        maximumFrontEnd: "Max FE Fee",
        maximumDeferredSalesCharge: "Max DSC Fee",
        trailerFee: "Trailer Fee",
        maximumFrontEndTrailer: "Max FE Trailer",
        maximumDeferredSalesChargeTrailer: "Max DSC Trailer",
        fundManager: "Fund Manager",
        portfolioManager: "Portfolio Manager",
        minInvestment: "Minimum investment",
        salesStatus: "Sales Status",
        salesCharges: "Sales Charges",
        salesChargeOption: "Type",
        whatYouPay: "What you pay",
        howItWorks: "How it works",
        inPerCent: "In percent (%)",
        inDollars: "In dollars ($)",
        frontEndSalesCharge: "Front-end sales charge",
        deferredSalesCharge: "Deferred sales charge",
        lowSalesCharge: "Low load sales charge",
        noDataFound: 'No data to display.',
        no: "No",
        yes: "Yes"
    }
})(inovestor.ms.fund);
; (function (fund, undefined) {
    fund.fees.resources = fund.fees.resources || {};
    fund.fees.resources["fr"] = {
        quickFacts: "Gestionnaire",
        fundCode: "Codes",
        dateSeriesStarted: "Création de la série",
        totalValueFund: "Valeur du fonds au",
        howSold: "Comment acheter",
        soldIn: "Vendu où",
        retirementSavingsPlanInitial: "REER initial",
        retirementSavingsPlanSubsequent: "REER subséquent",
        nonRetirementSavingsPlanInitial: "Non-REER initial",
        nonRetirementSavingsPlanSubsequent: "Non-REER subséquent",
        preauthorizedContributionAllowed: "PPA autorisé",
        preauthorizedContributionInitial: "PPA initial",
        preauthorizedContributionSubsequent: "PPA subséquent",
        systematicWithdrawalPlanAllowed: "PRS autorisé",
        systematicWithdrawalPlanMinimumBalance: "PRS solde min.",
        systematicWithdrawalPlanMinimumWithdrawal: "PRS retrait min.",
        managementFee: "Frais de gestion",
        managementExpenseRatio: "Ratio des frais de gestion (RFG)",
        managementExpenseRatioShort: "RFG",
        load: "Structure de frais",
        isChoiceOfFrontOrBackFee: "Frais souscription/rachat",
        maximumFrontEnd: "Frais d'aquisition max.",
        maximumDeferredSalesCharge: "FAR max.",
        trailerFee: "Commission de suivi",
        maximumFrontEndTrailer: "FA - Commission de suivi max.",
        maximumDeferredSalesChargeTrailer: "FAR - Commission de suivi max.",
        fundManager: "Gestionnaire du fonds",
        portfolioManager: "Gestionnaire de portefeuille",
        minInvestment: "Investissement min.",
        salesStatus: "Status des ventes",
        salesCharges: "Frais de vente",
        salesChargeOption: "Type",
        whatYouPay: "Ce que vous payez",
        howItWorks: "Fonctionnement",
        inPerCent: "En pourcentage (%)",
        inDollars: "En dollars ($)",
        frontEndSalesCharge: "Frais d'acquisition",
        deferredSalesCharge: "Frais de vente reportés",
        lowSalesCharge: "Frais de vente réduits",
        noDataFound: 'Aucune donnée à afficher.',
        no: "Non",
        yes: "Oui"
    }
})(inovestor.ms.fund);